import { styled } from '@mui/material';

import { OpenIcon, RefactoringUILogo, UXCelIcon } from '@app-velocity/icons';
import { TAppraisalDto } from '@app-velocity/av-api-v2';

export type AppraisalSourceProps = {
  review: TAppraisalDto;
};

const Source = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
  fontSize: 11,
  border: '1px solid #E8E8E8',
  color: 'var(--text-text-primary-color)',
  textDecoration: 'none',
  svg: {
    fill: 'var(--text-text-tertiary-color)',
  },
}));

const IconContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  background: '#F0F2F4',
  svg: {
    width: 12,
    height: 'auto'
  }
}));

const OpenIconContainer = styled('div')(({ theme }) => ({
  paddingRight: theme.spacing(2),
  marginLeft: 'auto',
}));

export const AppraisalSource = ({ review }: AppraisalSourceProps) => {
  const getIcon = () => {
    switch (review.categoryName) {
      case 'ACCESSIBILITY':
        return <UXCelIcon />;
      case 'GENERAL':
        return <RefactoringUILogo />;
    }
  };

  return (
    <Source target="__blank" href={review.ruleSourceUrl}>
      <IconContainer>{getIcon()}</IconContainer>
      {review.rule}
      <OpenIconContainer>
        <OpenIcon />
      </OpenIconContainer>
    </Source>
  );
};
